let API_GATEWAY_URL;

// 1. If an environment variable is explicitly injected during `npm run build`, use it:
if (process.env.REACT_APP_API_GATEWAY_URL) {
    API_GATEWAY_URL = process.env.REACT_APP_API_GATEWAY_URL;
}
// 2. Auto-detect DEV environments based on the URL the user is visiting
else if (window.location.hostname === 'localhost' || window.location.hostname.includes('dev')) {
    API_GATEWAY_URL = 'https://dev-api-commander-giga.azurewebsites.net';
}
// 3. Fallback to PRODUCTION automatically
else {
    API_GATEWAY_URL = 'https://api-commander-giga.azurewebsites.net';
}

export default API_GATEWAY_URL;